export const wassceGradeOptions = [
  // Core Subjects
  { value: 'A1 English Language', label: 'A1 English Language' },
  { value: 'B2 English Language', label: 'B2 English Language' },
  { value: 'B3 English Language', label: 'B3 English Language' },
  { value: 'C4 English Language', label: 'C4 English Language' },
  { value: 'C5 English Language', label: 'C5 English Language' },
  { value: 'C6 English Language', label: 'C6 English Language' },
  { value: 'D7 English Language', label: 'D7 English Language' },
  { value: 'E8 English Language', label: 'E8 English Language' },
  { value: 'F9 English Language', label: 'F9 English Language' },

  { value: 'A1 Core Mathematics', label: 'A1 Core Mathematics' },
  { value: 'B2 Core Mathematics', label: 'B2 Core Mathematics' },
  { value: 'B3 Core Mathematics', label: 'B3 Core Mathematics' },
  { value: 'C4 Core Mathematics', label: 'C4 Core Mathematics' },
  { value: 'C5 Core Mathematics', label: 'C5 Core Mathematics' },
  { value: 'C6 Core Mathematics', label: 'C6 Core Mathematics' },
  { value: 'D7 Core Mathematics', label: 'D7 Core Mathematics' },
  { value: 'E8 Core Mathematics', label: 'E8 Core Mathematics' },
  { value: 'F9 Core Mathematics', label: 'F9 Core Mathematics' },

  { value: 'A1 Integrated Science', label: 'A1 Integrated Science' },
  { value: 'B2 Integrated Science', label: 'B2 Integrated Science' },
  { value: 'B3 Integrated Science', label: 'B3 Integrated Science' },
  { value: 'C4 Integrated Science', label: 'C4 Integrated Science' },
  { value: 'C5 Integrated Science', label: 'C5 Integrated Science' },
  { value: 'C6 Integrated Science', label: 'C6 Integrated Science' },
  { value: 'D7 Integrated Science', label: 'D7 Integrated Science' },
  { value: 'E8 Integrated Science', label: 'E8 Integrated Science' },
  { value: 'F9 Integrated Science', label: 'F9 Integrated Science' },

  { value: 'A1 Social Studies', label: 'A1 Social Studies' },
  { value: 'B2 Social Studies', label: 'B2 Social Studies' },
  { value: 'B3 Social Studies', label: 'B3 Social Studies' },
  { value: 'C4 Social Studies', label: 'C4 Social Studies' },
  { value: 'C5 Social Studies', label: 'C5 Social Studies' },
  { value: 'C6 Social Studies', label: 'C6 Social Studies' },
  { value: 'D7 Social Studies', label: 'D7 Social Studies' },
  { value: 'E8 Social Studies', label: 'E8 Social Studies' },
  { value: 'F9 Social Studies', label: 'F9 Social Studies' },

  // General Science Electives
  { value: 'A1 Physics', label: 'A1 Physics' },
  { value: 'B2 Physics', label: 'B2 Physics' },
  { value: 'B3 Physics', label: 'B3 Physics' },
  { value: 'C4 Physics', label: 'C4 Physics' },
  { value: 'C5 Physics', label: 'C5 Physics' },
  { value: 'C6 Physics', label: 'C6 Physics' },
  { value: 'D7 Physics', label: 'D7 Physics' },
  { value: 'E8 Physics', label: 'E8 Physics' },
  { value: 'F9 Physics', label: 'F9 Physics' },

  { value: 'A1 Chemistry', label: 'A1 Chemistry' },
  { value: 'B2 Chemistry', label: 'B2 Chemistry' },
  { value: 'B3 Chemistry', label: 'B3 Chemistry' },
  { value: 'C4 Chemistry', label: 'C4 Chemistry' },
  { value: 'C5 Chemistry', label: 'C5 Chemistry' },
  { value: 'C6 Chemistry', label: 'C6 Chemistry' },
  { value: 'D7 Chemistry', label: 'D7 Chemistry' },
  { value: 'E8 Chemistry', label: 'E8 Chemistry' },
  { value: 'F9 Chemistry', label: 'F9 Chemistry' },

  { value: 'A1 Biology', label: 'A1 Biology' },
  { value: 'B2 Biology', label: 'B2 Biology' },
  { value: 'B3 Biology', label: 'B3 Biology' },
  { value: 'C4 Biology', label: 'C4 Biology' },
  { value: 'C5 Biology', label: 'C5 Biology' },
  { value: 'C6 Biology', label: 'C6 Biology' },
  { value: 'D7 Biology', label: 'D7 Biology' },
  { value: 'E8 Biology', label: 'E8 Biology' },
  { value: 'F9 Biology', label: 'F9 Biology' },

  {
    value: 'A1 Further Mathematics',
    label: 'A1 Further Mathematics(Elective)',
  },
  {
    value: 'B2 Further Mathematics',
    label: 'B2 Further Mathematics(Elective)',
  },
  {
    value: 'B3 Further Mathematics',
    label: 'B3 Further Mathematics(Elective)',
  },
  {
    value: 'C4 Further Mathematics',
    label: 'C4 Further Mathematics(Elective)',
  },
  {
    value: 'C5 Further Mathematics',
    label: 'C5 Further Mathematics(Elective)',
  },
  {
    value: 'C6 Further Mathematics',
    label: 'C6 Further Mathematics(Elective)',
  },
  {
    value: 'D7 Further Mathematics',
    label: 'D7 Further Mathematics(Elective)',
  },
  {
    value: 'E8 Further Mathematics',
    label: 'E8 Further Mathematics(Elective)',
  },
  {
    value: 'F9 Further Mathematics',
    label: 'F9 Further Mathematics(Elective)',
  },

  // Business Electives
  { value: 'A1 Financial Accounting', label: 'A1 Financial Accounting' },
  { value: 'B2 Financial Accounting', label: 'B2 Financial Accounting' },
  { value: 'B3 Financial Accounting', label: 'B3 Financial Accounting' },
  { value: 'C4 Financial Accounting', label: 'C4 Financial Accounting' },
  { value: 'C5 Financial Accounting', label: 'C5 Financial Accounting' },
  { value: 'C6 Financial Accounting', label: 'C6 Financial Accounting' },
  { value: 'D7 Financial Accounting', label: 'D7 Financial Accounting' },
  { value: 'E8 Financial Accounting', label: 'E8 Financial Accounting' },
  { value: 'F9 Financial Accounting', label: 'F9 Financial Accounting' },

  { value: 'A1 Business Management', label: 'A1 Business Management' },
  { value: 'B2 Business Management', label: 'B2 Business Management' },
  { value: 'B3 Business Management', label: 'B3 Business Management' },
  { value: 'C4 Business Management', label: 'C4 Business Management' },
  { value: 'C5 Business Management', label: 'C5 Business Management' },
  { value: 'C6 Business Management', label: 'C6 Business Management' },
  { value: 'D7 Business Management', label: 'D7 Business Management' },
  { value: 'E8 Business Management', label: 'E8 Business Management' },
  { value: 'F9 Business Management', label: 'F9 Business Management' },

  { value: 'A1 Economics', label: 'A1 Economics' },
  { value: 'B2 Economics', label: 'B2 Economics' },
  { value: 'B3 Economics', label: 'B3 Economics' },
  { value: 'C4 Economics', label: 'C4 Economics' },
  { value: 'C5 Economics', label: 'C5 Economics' },
  { value: 'C6 Economics', label: 'C6 Economics' },
  { value: 'D7 Economics', label: 'D7 Economics' },
  { value: 'E8 Economics', label: 'E8 Economics' },
  { value: 'F9 Economics', label: 'F9 Economics' },

  { value: 'A1 Commerce', label: 'A1 Commerce' },
  { value: 'B2 Commerce', label: 'B2 Commerce' },
  { value: 'B3 Commerce', label: 'B3 Commerce' },
  { value: 'C4 Commerce', label: 'C4 Commerce' },
  { value: 'C5 Commerce', label: 'C5 Commerce' },
  { value: 'C6 Commerce', label: 'C6 Commerce' },
  { value: 'D7 Commerce', label: 'D7 Commerce' },
  { value: 'E8 Commerce', label: 'E8 Commerce' },
  { value: 'F9 Commerce', label: 'F9 Commerce' },

  { value: 'A1 Principles of Cost Accounting', label: 'A1 Principles of Cost Accounting' },
  { value: 'B2 Principles of Cost Accounting', label: 'B2 Principles of Cost Accounting' },
  { value: 'B3 Principles of Cost Accounting', label: 'B3 Principles of Cost Accounting' },
  { value: 'C4 Principles of Cost Accounting', label: 'C4 Principles of Cost Accounting' },
  { value: 'C5 Principles of Cost Accounting', label: 'C5 Principles of Cost Accounting' },
  { value: 'C6 Principles of Cost Accounting', label: 'C6 Principles of Cost Accounting' },
  { value: 'D7 Principles of Cost Accounting', label: 'D7 Principles of Cost Accounting' },
  { value: 'E8 Principles of Cost Accounting', label: 'E8 Principles of Cost Accounting' },
  { value: 'F9 Principles of Cost Accounting', label: 'F9 Principles of Cost Accounting' },

  // General Arts Electives
  { value: 'A1 Literature in English', label: 'A1 Literature in English' },
  { value: 'B2 Literature in English', label: 'B2 Literature in English' },
  { value: 'B3 Literature in English', label: 'B3 Literature in English' },
  { value: 'C4 Literature in English', label: 'C4 Literature in English' },
  { value: 'C5 Literature in English', label: 'C5 Literature in English' },
  { value: 'C6 Literature in English', label: 'C6 Literature in English' },
  { value: 'D7 Literature in English', label: 'D7 Literature in English' },
  { value: 'E8 Literature in English', label: 'E8 Literature in English' },
  { value: 'F9 Literature in English', label: 'F9 Literature in English' },

  { value: 'A1 Government', label: 'A1 Government' },
  { value: 'B2 Government', label: 'B2 Government' },
  { value: 'B3 Government', label: 'B3 Government' },
  { value: 'C4 Government', label: 'C4 Government' },
  { value: 'C5 Government', label: 'C5 Government' },
  { value: 'C6 Government', label: 'C6 Government' },
  { value: 'D7 Government', label: 'D7 Government' },
  { value: 'E8 Government', label: 'E8 Government' },
  { value: 'F9 Government', label: 'F9 Government' },

  { value: 'A1 Geography', label: 'A1 Geography' },
  { value: 'B2 Geography', label: 'B2 Geography' },
  { value: 'B3 Geography', label: 'B3 Geography' },
  { value: 'C4 Geography', label: 'C4 Geography' },
  { value: 'C5 Geography', label: 'C5 Geography' },
  { value: 'C6 Geography', label: 'C6 Geography' },
  { value: 'D7 Geography', label: 'D7 Geography' },
  { value: 'E8 Geography', label: 'E8 Geography' },
  { value: 'F9 Geography', label: 'F9 Geography' },

  { value: 'A1 History', label: 'A1 History' },
  { value: 'B2 History', label: 'B2 History' },
  { value: 'B3 History', label: 'B3 History' },
  { value: 'C4 History', label: 'C4 History' },
  { value: 'C5 History', label: 'C5 History' },
  { value: 'C6 History', label: 'C6 History' },
  { value: 'D7 History', label: 'D7 History' },
  { value: 'E8 History', label: 'E8 History' },
  { value: 'F9 History', label: 'F9 History' },

  {
    value: 'A1 Christian Religious Studies (CRS)',
    label: 'A1 Christian Religious Studies (CRS)',
  },
  {
    value: 'B2 Christian Religious Studies (CRS)',
    label: 'B2 Christian Religious Studies (CRS)',
  },
  {
    value: 'B3 Christian Religious Studies (CRS)',
    label: 'B3 Christian Religious Studies (CRS)',
  },
  {
    value: 'C4 Christian Religious Studies (CRS)',
    label: 'C4 Christian Religious Studies (CRS)',
  },
  {
    value: 'C5 Christian Religious Studies (CRS)',
    label: 'C5 Christian Religious Studies (CRS)',
  },
  {
    value: 'C6 Christian Religious Studies (CRS)',
    label: 'C6 Christian Religious Studies (CRS)',
  },
  {
    value: 'D7 Christian Religious Studies (CRS)',
    label: 'D7 Christian Religious Studies (CRS)',
  },
  {
    value: 'E8 Christian Religious Studies (CRS)',
    label: 'E8 Christian Religious Studies (CRS)',
  },
  {
    value: 'F9 Christian Religious Studies (CRS)',
    label: 'F9 Christian Religious Studies (CRS)',
  },

  { value: 'A1 Islamic Religious Studies (IRS)', label: 'A1 Islamic Religious Studies (IRS)' },
  { value: 'B2 Islamic Religious Studies (IRS)', label: 'B2 Islamic Religious Studies (IRS)' },
  { value: 'B3 Islamic Religious Studies (IRS)', label: 'B3 Islamic Religious Studies (IRS)' },
  { value: 'C4 Islamic Religious Studies (IRS)', label: 'C4 Islamic Religious Studies (IRS)' },
  { value: 'C5 Islamic Religious Studies (IRS)', label: 'C5 Islamic Religious Studies (IRS)' },
  { value: 'C6 Islamic Religious Studies (IRS)', label: 'C6 Islamic Religious Studies (IRS)' },
  { value: 'D7 Islamic Religious Studies (IRS)', label: 'D7 Islamic Religious Studies (IRS)' },
  { value: 'E8 Islamic Religious Studies (IRS)', label: 'E8 Islamic Religious Studies (IRS)' },
  { value: 'F9 Islamic Religious Studies (IRS)', label: 'F9 Islamic Religious Studies (IRS)' },

  { value: 'A1 Music', label: 'A1 Music' },
  { value: 'B2 Music', label: 'B2 Music' },
  { value: 'B3 Music', label: 'B3 Music' },
  { value: 'C4 Music', label: 'C4 Music' },
  { value: 'C5 Music', label: 'C5 Music' },
  { value: 'C6 Music', label: 'C6 Music' },
  { value: 'D7 Music', label: 'D7 Music' },
  { value: 'E8 Music', label: 'E8 Music' },
  { value: 'F9 Music', label: 'F9 Music' },

  // Vocational/Home Economics Electives
  { value: 'A1 Foods and Nutrition', label: 'A1 Foods and Nutrition' },
  { value: 'B2 Foods and Nutrition', label: 'B2 Foods and Nutrition' },
  { value: 'B3 Foods and Nutrition', label: 'B3 Foods and Nutrition' },
  { value: 'C4 Foods and Nutrition', label: 'C4 Foods and Nutrition' },
  { value: 'C5 Foods and Nutrition', label: 'C5 Foods and Nutrition' },
  { value: 'C6 Foods and Nutrition', label: 'C6 Foods and Nutrition' },
  { value: 'D7 Foods and Nutrition', label: 'D7 Foods and Nutrition' },
  { value: 'E8 Foods and Nutrition', label: 'E8 Foods and Nutrition' },
  { value: 'F9 Foods and Nutrition', label: 'F9 Foods and Nutrition' },

  { value: 'A1 Clothing and Textiles', label: 'A1 Clothing and Textiles' },
  { value: 'B2 Clothing and Textiles', label: 'B2 Clothing and Textiles' },
  { value: 'B3 Clothing and Textiles', label: 'B3 Clothing and Textiles' },
  { value: 'C4 Clothing and Textiles', label: 'C4 Clothing and Textiles' },
  { value: 'C5 Clothing and Textiles', label: 'C5 Clothing and Textiles' },
  { value: 'C6 Clothing and Textiles', label: 'C6 Clothing and Textiles' },
  { value: 'D7 Clothing and Textiles', label: 'D7 Clothing and Textiles' },
  { value: 'E8 Clothing and Textiles', label: 'E8 Clothing and Textiles' },
  { value: 'F9 Clothing and Textiles', label: 'F9 Clothing and Textiles' },

  { value: 'A1 Management-in-Living', label: 'A1 Management-in-Living' },
  { value: 'B2 Management-in-Living', label: 'B2 Management-in-Living' },
  { value: 'B3 Management-in-Living', label: 'B3 Management-in-Living' },
  { value: 'C4 Management-in-Living', label: 'C4 Management-in-Living' },
  { value: 'C5 Management-in-Living', label: 'C5 Management-in-Living' },
  { value: 'C6 Management-in-Living', label: 'C6 Management-in-Living' },
  { value: 'D7 Management-in-Living', label: 'D7 Management-in-Living' },
  { value: 'E8 Management-in-Living', label: 'E8 Management-in-Living' },
  { value: 'F9 Management-in-Living', label: 'F9 Management-in-Living' },

  // Visual Arts Electives
  {
    value: 'A1 General Knowledge in Art',
    label: 'A1 General Knowledge in Art',
  },
  {
    value: 'B2 General Knowledge in Art',
    label: 'B2 General Knowledge in Art',
  },
  {
    value: 'B3 General Knowledge in Art',
    label: 'B3 General Knowledge in Art',
  },
  {
    value: 'C4 General Knowledge in Art',
    label: 'C4 General Knowledge in Art',
  },
  {
    value: 'C5 General Knowledge in Art',
    label: 'C5 General Knowledge in Art',
  },
  {
    value: 'C6 General Knowledge in Art',
    label: 'C6 General Knowledge in Art',
  },
  {
    value: 'D7 General Knowledge in Art',
    label: 'D7 General Knowledge in Art',
  },
  {
    value: 'E8 General Knowledge in Art',
    label: 'E8 General Knowledge in Art',
  },
  {
    value: 'F9 General Knowledge in Art',
    label: 'F9 General Knowledge in Art',
  },

  { value: 'A1 Graphic Design', label: 'A1 Graphic Design' },
  { value: 'B2 Graphic Design', label: 'B2 Graphic Design' },
  { value: 'B3 Graphic Design', label: 'B3 Graphic Design' },
  { value: 'C4 Graphic Design', label: 'C4 Graphic Design' },
  { value: 'C5 Graphic Design', label: 'C5 Graphic Design' },
  { value: 'C6 Graphic Design', label: 'C6 Graphic Design' },
  { value: 'D7 Graphic Design', label: 'D7 Graphic Design' },
  { value: 'E8 Graphic Design', label: 'E8 Graphic Design' },
  { value: 'F9 Graphic Design', label: 'F9 Graphic Design' },

  { value: 'A1 Picture Making', label: 'A1 Picture Making' },
  { value: 'B2 Picture Making', label: 'B2 Picture Making' },
  { value: 'B3 Picture Making', label: 'B3 Picture Making' },
  { value: 'C4 Picture Making', label: 'C4 Picture Making' },
  { value: 'C5 Picture Making', label: 'C5 Picture Making' },
  { value: 'C6 Picture Making', label: 'C6 Picture Making' },
  { value: 'D7 Picture Making', label: 'D7 Picture Making' },
  { value: 'E8 Picture Making', label: 'E8 Picture Making' },
  { value: 'F9 Picture Making', label: 'F9 Picture Making' },



  { value: 'A1 Ceramics', label: 'A1 Ceramics' },
  { value: 'B2 Ceramics', label: 'B2 Ceramics' },
  { value: 'B3 Ceramics', label: 'B3 Ceramics' },
  { value: 'C4 Ceramics', label: 'C4 Ceramics' },
  { value: 'C5 Ceramics', label: 'C5 Ceramics' },
  { value: 'C6 Ceramics', label: 'C6 Ceramics' },
  { value: 'D7 Ceramics', label: 'D7 Ceramics' },
  { value: 'E8 Ceramics', label: 'E8 Ceramics' },
  { value: 'F9 Ceramics', label: 'F9 Ceramics' },

  { value: 'A1 Textiles', label: 'A1 Textiles' },
  { value: 'B2 Textiles', label: 'B2 Textiles' },
  { value: 'B3 Textiles', label: 'B3 Textiles' },
  { value: 'C4 Textiles', label: 'C4 Textiles' },
  { value: 'C5 Textiles', label: 'C5 Textiles' },
  { value: 'C6 Textiles', label: 'C6 Textiles' },
  { value: 'D7 Textiles', label: 'D7 Textiles' },
  { value: 'E8 Textiles', label: 'E8 Textiles' },
  { value: 'F9 Textiles', label: 'F9 Textiles' },

  { value: 'A1 Sculpture', label: 'A1 Sculpture' },
  { value: 'B2 Sculpture', label: 'B2 Sculpture' },
  { value: 'B3 Sculpture', label: 'B3 Sculpture' },
  { value: 'C4 Sculpture', label: 'C4 Sculpture' },
  { value: 'C5 Sculpture', label: 'C5 Sculpture' },
  { value: 'C6 Sculpture', label: 'C6 Sculpture' },
  { value: 'D7 Sculpture', label: 'D7 Sculpture' },
  { value: 'E8 Sculpture', label: 'E8 Sculpture' },
  { value: 'F9 Sculpture', label: 'F9 Sculpture' },

  { value: 'A1 Leatherwork', label: 'A1 Leatherwork' },
  { value: 'B2 Leatherwork', label: 'B2 Leatherwork' },
  { value: 'B3 Leatherwork', label: 'B3 Leatherwork' },
  { value: 'C4 Leatherwork', label: 'C4 Leatherwork' },
  { value: 'C5 Leatherwork', label: 'C5 Leatherwork' },
  { value: 'C6 Leatherwork', label: 'C6 Leatherwork' },
  { value: 'D7 Leatherwork', label: 'D7 Leatherwork' },
  { value: 'E8 Leatherwork', label: 'E8 Leatherwork' },
  { value: 'F9 Leatherwork', label: 'F9 Leatherwork' },

  { value: 'A1 Basketry', label: 'A1 Basketry' },
  { value: 'B2 Basketry', label: 'B2 Basketry' },
  { value: 'B3 Basketry', label: 'B3 Basketry' },
  { value: 'C4 Basketry', label: 'C4 Basketry' },
  { value: 'C5 Basketry', label: 'C5 Basketry' },
  { value: 'C6 Basketry', label: 'C6 Basketry' },
  { value: 'D7 Basketry', label: 'D7 Basketry' },
  { value: 'E8 Basketry', label: 'E8 Basketry' },
  { value: 'F9 Basketry', label: 'F9 Basketry' },

  { value: 'A1 Jewellery', label: 'A1 Jewellery' },
  { value: 'B2 Jewellery', label: 'B2 Jewellery' },
  { value: 'B3 Jewellery', label: 'B3 Jewellery' },
  { value: 'C4 Jewellery', label: 'C4 Jewellery' },
  { value: 'C5 Jewellery', label: 'C5 Jewellery' },
  { value: 'C6 Jewellery', label: 'C6 Jewellery' },
  { value: 'D7 Jewellery', label: 'D7 Jewellery' },
  { value: 'E8 Jewellery', label: 'E8 Jewellery' },
  { value: 'F9 Jewellery', label: 'F9 Jewellery' },


  // Technical Electives
  { value: 'A1 Technical Drawing', label: 'A1 Technical Drawing' },
  { value: 'B2 Technical Drawing', label: 'B2 Technical Drawing' },
  { value: 'B3 Technical Drawing', label: 'B3 Technical Drawing' },
  { value: 'C4 Technical Drawing', label: 'C4 Technical Drawing' },
  { value: 'C5 Technical Drawing', label: 'C5 Technical Drawing' },
  { value: 'C6 Technical Drawing', label: 'C6 Technical Drawing' },
  { value: 'D7 Technical Drawing', label: 'D7 Technical Drawing' },
  { value: 'E8 Technical Drawing', label: 'E8 Technical Drawing' },
  { value: 'F9 Technical Drawing', label: 'F9 Technical Drawing' },

  { value: 'A1 Applied Electricity', label: 'A1 Applied Electricity' },
  { value: 'B2 Applied Electricity', label: 'B2 Applied Electricity' },
  { value: 'B3 Applied Electricity', label: 'B3 Applied Electricity' },
  { value: 'C4 Applied Electricity', label: 'C4 Applied Electricity' },
  { value: 'C5 Applied Electricity', label: 'C5 Applied Electricity' },
  { value: 'C6 Applied Electricity', label: 'C6 Applied Electricity' },
  { value: 'D7 Applied Electricity', label: 'D7 Applied Electricity' },
  { value: 'E8 Applied Electricity', label: 'E8 Applied Electricity' },
  { value: 'F9 Applied Electricity', label: 'F9 Applied Electricity' },

  { value: 'A1 Auto Mechanics', label: 'A1 Auto Mechanics' },
  { value: 'B2 Auto Mechanics', label: 'B2 Auto Mechanics' },
  { value: 'B3 Auto Mechanics', label: 'B3 Auto Mechanics' },
  { value: 'C4 Auto Mechanics', label: 'C4 Auto Mechanics' },
  { value: 'C5 Auto Mechanics', label: 'C5 Auto Mechanics' },
  { value: 'C6 Auto Mechanics', label: 'C6 Auto Mechanics' },
  { value: 'D7 Auto Mechanics', label: 'D7 Auto Mechanics' },
  { value: 'E8 Auto Mechanics', label: 'E8 Auto Mechanics' },
  { value: 'F9 Auto Mechanics', label: 'F9 Auto Mechanics' },

  { value: 'A1 Building Construction', label: 'A1 Building Construction' },
  { value: 'B2 Building Construction', label: 'B2 Building Construction' },
  { value: 'B3 Building Construction', label: 'B3 Building Construction' },
  { value: 'C4 Building Construction', label: 'C4 Building Construction' },
  { value: 'C5 Building Construction', label: 'C5 Building Construction' },
  { value: 'C6 Building Construction', label: 'C6 Building Construction' },
  { value: 'D7 Building Construction', label: 'D7 Building Construction' },
  { value: 'E8 Building Construction', label: 'E8 Building Construction' },
  { value: 'F9 Building Construction', label: 'F9 Building Construction' },

  { value: 'A1 Woodwork', label: 'A1 Woodwork' },
  { value: 'B2 Woodwork', label: 'B2 Woodwork' },
  { value: 'B3 Woodwork', label: 'B3 Woodwork' },
  { value: 'C4 Woodwork', label: 'C4 Woodwork' },
  { value: 'C5 Woodwork', label: 'C5 Woodwork' },
  { value: 'C6 Woodwork', label: 'C6 Woodwork' },
  { value: 'D7 Woodwork', label: 'D7 Woodwork' },
  { value: 'E8 Woodwork', label: 'E8 Woodwork' },
  { value: 'F9 Woodwork', label: 'F9 Woodwork' },

  { value: 'A1 Metalwork', label: 'A1 Metalwork' },
  { value: 'B2 Metalwork', label: 'B2 Metalwork' },
  { value: 'B3 Metalwork', label: 'B3 Metalwork' },
  { value: 'C4 Metalwork', label: 'C4 Metalwork' },
  { value: 'C5 Metalwork', label: 'C5 Metalwork' },
  { value: 'C6 Metalwork', label: 'C6 Metalwork' },
  { value: 'D7 Metalwork', label: 'D7 Metalwork' },
  { value: 'E8 Metalwork', label: 'E8 Metalwork' },
  { value: 'F9 Metalwork', label: 'F9 Metalwork' },

  { value: 'A1 Electronics', label: 'A1 Electronics' },
  { value: 'B2 Electronics', label: 'B2 Electronics' },
  { value: 'B3 Electronics', label: 'B3 Electronics' },
  { value: 'C4 Electronics', label: 'C4 Electronics' },
  { value: 'C5 Electronics', label: 'C5 Electronics' },
  { value: 'C6 Electronics', label: 'C6 Electronics' },
  { value: 'D7 Electronics', label: 'D7 Electronics' },
  { value: 'E8 Electronics', label: 'E8 Electronics' },
  { value: 'F9 Electronics', label: 'F9 Electronics' },

  // Other Electives (Agriculture & General)

  { value: 'A1 General Agriculture', label: 'A1 General Agriculture' },
  { value: 'B2 General Agriculture', label: 'B2 General Agriculture' },
  { value: 'B3 General Agriculture', label: 'B3 General Agriculture' },
  { value: 'C4 General Agriculture', label: 'C4 General Agriculture' },
  { value: 'C5 General Agriculture', label: 'C5 General Agriculture' },
  { value: 'C6 General Agriculture', label: 'C6 General Agriculture' },
  { value: 'D7 General Agriculture', label: 'D7 General Agriculture' },
  { value: 'E8 General Agriculture', label: 'E8 General Agriculture' },
  { value: 'F9 General Agriculture', label: 'F9 General Agriculture' },

  { value: 'A1 Animal Husbandry', label: 'A1 Animal Husbandry' },
  { value: 'B2 Animal Husbandry', label: 'B2 Animal Husbandry' },
  { value: 'B3 Animal Husbandry', label: 'B3 Animal Husbandry' },
  { value: 'C4 Animal Husbandry', label: 'C4 Animal Husbandry' },
  { value: 'C5 Animal Husbandry', label: 'C5 Animal Husbandry' },
  { value: 'C6 Animal Husbandry', label: 'C6 Animal Husbandry' },
  { value: 'D7 Animal Husbandry', label: 'D7 Animal Husbandry' },
  { value: 'E8 Animal Husbandry', label: 'E8 Animal Husbandry' },
  { value: 'F9 Animal Husbandry', label: 'F9 Animal Husbandry' },

  { value: 'A1 Crop Husbandry and Horticulture', label: 'A1 Crop Husbandry and Horticulture' },
  { value: 'B2 Crop Husbandry and Horticulture', label: 'B2 Crop Husbandry and Horticulture' },
  { value: 'B3 Crop Husbandry and Horticulture', label: 'B3 Crop Husbandry and Horticulture' },
  { value: 'C4 Crop Husbandry and Horticulture', label: 'C4 Crop Husbandry and Horticulture' },
  { value: 'C5 Crop Husbandry and Horticulture', label: 'C5 Crop Husbandry and Horticulture' },
  { value: 'C6 Crop Husbandry and Horticulture', label: 'C6 Crop Husbandry and Horticulture' },
  { value: 'D7 Crop Husbandry and Horticulture', label: 'D7 Crop Husbandry and Horticulture' },
  { value: 'E8 Crop Husbandry and Horticulture', label: 'E8 Crop Husbandry and Horticulture' },
  { value: 'F9 Crop Husbandry and Horticulture', label: 'F9 Crop Husbandry and Horticulture' },

  {
    value: 'A1 Information & Communication Technology (ICT)',
    label: 'A1 Information & Communication Technology (ICT)',
  },
  {
    value: 'B2 Information & Communication Technology (ICT)',
    label: 'B2 Information & Communication Technology (ICT)',
  },
  {
    value: 'B3 Information & Communication Technology (ICT)',
    label: 'B3 Information & Communication Technology (ICT)',
  },
  {
    value: 'C4 Information & Communication Technology (ICT)',
    label: 'C4 Information & Communication Technology (ICT)',
  },
  {
    value: 'C5 Information & Communication Technology (ICT)',
    label: 'C5 Information & Communication Technology (ICT)',
  },
  {
    value: 'C6 Information & Communication Technology (ICT)',
    label: 'C6 Information & Communication Technology (ICT)',
  },
  {
    value: 'D7 Information & Communication Technology (ICT)',
    label: 'D7 Information & Communication Technology (ICT)',
  },
  {
    value: 'E8 Information & Communication Technology (ICT)',
    label: 'E8 Information & Communication Technology (ICT)',
  },
  {
    value: 'F9 Information & Communication Technology (ICT)',
    label: 'F9 Information & Communication Technology (ICT)',
  },

  { value: 'A1 French', label: 'A1 French' },
  { value: 'B2 French', label: 'B2 French' },
  { value: 'B3 French', label: 'B3 French' },
  { value: 'C4 French', label: 'C4 French' },
  { value: 'C5 French', label: 'C5 French' },
  { value: 'C6 French', label: 'C6 French' },
  { value: 'D7 French', label: 'D7 French' },
  { value: 'E8 French', label: 'E8 French' },
  { value: 'F9 French', label: 'F9 French' },
];
